import { render, staticRenderFns } from "./vip_privilege.vue?vue&type=template&id=bceb8564&scoped=true&"
import script from "./vip_privilege.vue?vue&type=script&lang=js&"
export * from "./vip_privilege.vue?vue&type=script&lang=js&"
import style0 from "./vip_privilege.vue?vue&type=style&index=0&id=bceb8564&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bceb8564",
  null
  
)

export default component.exports